import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { TableCell, TableRow } from '@mui/material';

import {
    loadContractDetailsForContractId,
    loadServiceDetailsForContractId
} from '../../../store/directusService';
import { loadParticipantByPtCode } from '../../../store/participantService';

import classes from '../../../commonStyles/tables.module.css';

const CallsDueTableRow = ({ row, showSensitiveCells }) => {
    // HOOKS
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // LOCAL STATE
    const [isPTRequestSent, setIsPTRequestSent] = useState(false);

    // STORE STATE
    const currentParticipant = useSelector(
        (state) => state.entities.participantService.currentParticipant
    );
    const contractDetailsById = useSelector(
        (state) => state.entities.directusService.contractDetailsById
    );
    const servicesByContractId = useSelector(
        (state) => state.entities.directusService.servicesByContractId
    );

    // USE EFFECTS
    useEffect(() => {
        if (isPTRequestSent && currentParticipant.ptCode === row.ptCode) {
            if (!(currentParticipant.contractId in contractDetailsById))
                dispatch(loadContractDetailsForContractId(currentParticipant.contractId));
            if (!(currentParticipant.contractId in servicesByContractId))
                dispatch(loadServiceDetailsForContractId(currentParticipant.contractId));
        }
    }, [isPTRequestSent, currentParticipant]);

    useEffect(() => {
        if (
            isPTRequestSent &&
            currentParticipant?.ptCode === row.ptCode &&
            contractDetailsById[currentParticipant.contractId] &&
            servicesByContractId[currentParticipant.contractId]
        )
            navigate('/edit_participant');
    }, [isPTRequestSent, contractDetailsById, servicesByContractId, currentParticipant]);

    // EVENT HANDLERS
    const onClickPTCode = () => {
        if (!row?.ptCode) return;
        dispatch(loadParticipantByPtCode(row.ptCode));
        setIsPTRequestSent(true);
    };

    // RENDER
    return (
        <TableRow key={row.id} hover className={`${classes.basicRowStripes}`}>
            <TableCell className={classes.rowLink} onClick={onClickPTCode}>
                {row?.ptCode}
            </TableCell>
            {showSensitiveCells && <TableCell>{row?.firstName}</TableCell>}
            {showSensitiveCells && <TableCell>{row?.lastName}</TableCell>}
            {showSensitiveCells && <TableCell>{row?.adviser}</TableCell>}
        </TableRow>
    );
};

CallsDueTableRow.propTypes = {
    row: PropTypes.object,
    showSensitiveCells: PropTypes.bool.isRequired
};

export default CallsDueTableRow;
